import { z } from "zod";

/**
 * auth-service's permissions and roles on the wire (DEDUPE-2 §3.3): one
 * schema for both apps, ported from admin's parsers (`authValidation.ts`),
 * which filled absent bookkeeping fields the same way.
 */

const optionalText = z.string().nullish();

export const permissionSchema = z.object({
  id: z.number(),
  objectType: z.string(),
  name: z.string(),
  level: z.string(),
  version: z
    .number()
    .nullish()
    .transform((value) => value ?? 0),
  createdAt: optionalText.transform((value) => value ?? ""),
  updatedAt: optionalText.transform((value) => value ?? ""),
  description: optionalText,
});
export type Permission = z.output<typeof permissionSchema>;

const permissions = z
  .array(permissionSchema)
  .nullish()
  .transform((value) => value ?? []);

/** A role of an organization's (`auth/api/v1/organizations/:o/roles`). */
export const organizationRoleSchema = z.object({
  id: z.number(),
  // Null on the platform's own roles (auth-service `role.entity.ts`).
  organizationId: z
    .number()
    .nullish()
    .transform((value) => value ?? null),
  objectType: z.string(),
  name: z.string(),
  version: z
    .number()
    .nullish()
    .transform((value) => value ?? 0),
  createdAt: optionalText.transform((value) => value ?? ""),
  updatedAt: optionalText.transform((value) => value ?? ""),
  deletedAt: optionalText,
  permissions,
});
export type OrganizationRole = z.output<typeof organizationRoleSchema>;

/** A platform management role (`auth/api/v1/roles`). */
export const managementRoleSchema = z.object({
  id: z.number(),
  name: z.string(),
  global: z.boolean(),
  objectType: optionalText.transform((value) => value ?? "management"),
  version: z
    .number()
    .nullish()
    .transform((value) => value ?? 0),
  createdAt: optionalText.transform((value) => value ?? ""),
  updatedAt: optionalText.transform((value) => value ?? ""),
  deletedAt: optionalText,
  permissions,
});
export type ManagementRole = z.output<typeof managementRoleSchema>;
